import React from "react";
import {
    FaFileInvoiceDollar,
    FaCalendarAlt,
    FaMoneyBillWave,
    FaRegClock,
    FaLink,
    FaFilePdf,
    FaReceipt,
    FaArrowRight,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { LoadingMessage, formatVisitDate, currencySymbols } from '../../../Common/CommonVariables';
import { store } from '../../../Store/store';
import { useInvoicePayNow } from "../../../Common/CommonAccessFile";


const CC_InvoiceListComponent = ({ data }) => {
    const accessToInvoicePayNow = useInvoicePayNow();

    const invoices = data?.invDetails?.slice(0, 3) || [];
    const userInfo = store.getState();

    const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split("/");
    return new Date(`${year}-${month}-${day}`);
    };

    const testCurrentDate = parseDate("02/10/2025");

    return (
        // <div className="card">
        //     <div className="card-body pb-1 pt-1">
        <div>

            <div className="card border mb-1" style={{ fontSize: '12px' }}>
                <div className="card-header fw-bold py-2 d-flex justify-content-between align-items-center">
                    <span>Last 3 months invoices</span>
                </div>

                <div

                    className="px-2"
                    style={{
                        maxHeight: invoices.length > 2 ? '200px' : 'auto',
                        overflowY: invoices.length > 2 ? 'auto' : 'visible',
                    }}
                >
                    {invoices.map((invoice, idx) => (
                        <div key={idx}>
                            <div className="border-bottom py-2 px-1">
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                    <div>
                                        <strong>Inv No:</strong> {invoice.invoiceNumber}
                                        {/* <span className="text-muted">({invoice.invoiceStatus})</span> */}
                                    </div>
                                    {invoice.freepayQRCodeLink && accessToInvoicePayNow && (
                                        <button
                                            onClick={() =>
                                                window.open(invoice.freepayQRCodeLink, "_blank")
                                            }
                                            className="btn btn-sm pay-nowbtn"
                                            style={{
                                                fontSize: "8px",
                                                position: "relative",
                                                top: "-2px" // adjust value to control how far up you want it
                                            }}
                                        >
                                            Pay Now
                                        </button>

                                    )}
                                </div>

                                <div className="row mt-1">
                                    <div className="col-6">
                                        <strong>Inv Date:</strong> {invoice.invoiceDate}
                                    </div>
                                    <div className="col-6">
                                        <strong>Due Date: </strong>
                                        <span
                                            className={
                                            new Date() > parseDate(invoice.invoiceDueDate) ? "text-danger font-semibold" : ""
                                            }
                                        >
                                            {invoice.invoiceDueDate}
                                        </span>
                                    </div>
                                </div>

                                <div className="row mt-1">
                                    <div className="col-6">
                                        <strong>Inv Amt:</strong> {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{invoice.invoiceAmount}
                                    </div>
                                    <div className="col-6">
                                        <strong>O/S Amt:</strong> {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{invoice.invoiceOpenAmount}
                                    </div>
                                </div>
                            </div>

                            {/* {idx !== invoices.length - 1 && <hr className="my-1" />} */}
                        </div>
                    ))}
                </div>
            </div>

            {/* View All Link */}
            <div className="text-end mt-2">
                <a
                    href="/invoices"
                    className="btn btn-link fw-bold small p-0"
                    style={{ fontSize: "12px", color: '#00984A', marginBottom: '-6px' }}
                >
                    View All Invoices <FaArrowRight className="ms-1" style={{ fontSize: "12px" }} />
                </a>
            </div>
        </div >
    );
};

export default CC_InvoiceListComponent;

// const CC_InvoiceListComponent = ({ data }) => {
//     const navigate = useNavigate();

//     const invoices = data?.invDetails?.slice(0, 3) || [];
//     const balance = data?.ClientGLBalance || 0;
//     const outstanding = data?.ClientOutstandingAmt || 0;

//     const currentInvoiceDate = (() => {
//         const rawDate = invoices?.[0]?.invoiceDate;
//         if (!rawDate) return "N/A";
//         const [day, month, year] = rawDate.split("/");
//         const parsedDate = new Date(`${year}-${month}-${day}`);
//         const shortMonth = parsedDate.toLocaleString("en-US", { month: "short" });
//         return `${shortMonth}/${year}`;
//     })();

//     return (

//         <div className="card shadow-sm">
//             <div className="card-body pb-2 pt-2">
//                 {/* Header with Total Outstanding */}
//                 <div className="d-flex justify-content-between align-items-center mb-2">
//                     <h6 className="mb-0">
//                         <FaReceipt className="text-danger me-2" />
//                         <strong>Invoices</strong>
//                     </h6>
//                     <small className="text-muted">
//                         Total Outstanding: <strong className="text-danger">{currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{balance}</strong>
//                     </small>
//                 </div>

//                 {/* Invoice list */}
//                 <div
//                     className="list-group mb-2"
//                     style={{ maxHeight: "200px", overflowY: "auto", fontSize: "12px" }}
//                 >
//                     {invoices.map((invoice, idx) => (
//                         <div
//                             key={idx}
//                             className="list-group-item py-2 px-2 border rounded mb-1"
//                         >
//                             {/* Row 1: Invoice No and Pay Now */}
//                             <div className="d-flex justify-content-between align-items-center">
//                                 <div>
//                                     <strong>Inv No:</strong> {invoice.invoiceNumber}{" "}
//                                     <span className="text-muted">({invoice.invoiceStatus})</span>
//                                 </div>
//                                 {invoice.freepayQRCodeLink && (
//                                     <button
//                                         onClick={() =>
//                                             window.open(invoice.freepayQRCodeLink, "_blank")
//                                         }
//                                         className="btn btn-sm btn-outline-primary py-0 px-2"
//                                         style={{ fontSize: "10px" }}
//                                     >
//                                         Pay Now
//                                     </button>
//                                 )}
//                             </div>

//                             {/* Row 2: Dates */}
//                             <div className="d-flex justify-content-between mt-1">
//                                 <div>
//                                     <span className="me-3">
//                                         <strong>Inv Date:</strong> {invoice.invoiceDate}
//                                     </span>
//                                     <span>
//                                         <strong>Due Date:</strong> {invoice.invoiceDueDate}
//                                     </span>
//                                 </div>
//                             </div>

//                             {/* Row 3: Amounts */}
//                             <div className="d-flex justify-content-between mt-1">
//                                 <span>
//                                     <strong>Amt:</strong> {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{invoice.invoiceAmount}
//                                 </span>
//                                 <span>
//                                     <strong>O/S Amt:</strong> {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{invoice.invoiceOpenAmount}
//                                 </span>
//                             </div>
//                         </div>
//                     ))}
//                 </div>

//                 {/* View All Link */}
//                 <div className="text-end">
//                     <a
//                         href="/invoices"
//                         className="text-primary small text-decoration-none"
//                         style={{ fontSize: "11px" }}
//                     >
//                         View All Invoices <FaArrowRight className="ms-1" style={{ fontSize: "9px" }} />
//                     </a>
//                 </div>
//             </div>
//         </div>

//     );
// };

// export default CC_InvoiceListComponent;
